import { Navigate } from 'react-router-dom';
import { usePermissions } from '../../hooks/usePermissions';
import Spinner from '../ui/Spinner/Spinner';
import type { ReactNode } from 'react';

/**
 * Route guard for /admin/* routes.
 * Redirects users without admin access back to home.
 */
export default function AdminGuard({ children }: { children: ReactNode }) {
  const { isLoading, canAccessAdmin } = usePermissions();

  if (isLoading) {
    return <Spinner overlay text="Checking permissions…" />;
  }

  if (!canAccessAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
